import { FC } from 'react';
import { Stack, ThemeProvider } from '@mui/material';

import { passengerThemeV2 } from '@mopla/mui';
import {
	MplDeutschlandTicketCardLoading,
	MplTopSectionHeaderLoading,
} from '@mopla/ui';
import {
	StyledDTicketPageLayoutContainer,
	StyledDTicketPageLayoutContent,
	StyledSafeAreaHeader,
} from '@mopla/ui';

interface IUserDTicketLoadingProps {
	onBack: () => void;
}

export const UserDTicketLoading: FC<IUserDTicketLoadingProps> = ({
	onBack,
}) => {
	return (
		<ThemeProvider theme={passengerThemeV2}>
			<StyledDTicketPageLayoutContainer>
				<StyledSafeAreaHeader>
					<MplTopSectionHeaderLoading onBack={onBack} />
				</StyledSafeAreaHeader>

				<StyledDTicketPageLayoutContent scrollable={true}>
					<Stack gap={5}>
						<Stack alignItems="center" sx={{ width: '100%' }}>
							<MplDeutschlandTicketCardLoading />
						</Stack>
					</Stack>
				</StyledDTicketPageLayoutContent>
			</StyledDTicketPageLayoutContainer>
		</ThemeProvider>
	);
};
